import React from 'react'
import PropTypes from 'prop-types'
import { Element } from 'react-scroll'

import SocialButtons from 'Pods/Shared/SocialButtons'

import Section from './Section'

function Contacts({ id }) {
  return (
    <Element id={id} className="element">
      <Section sectionClassName="info-section contacts-section">
        <div className="col-12 col-md-6 col-lg-5 contacts-section__left-column">
          <div>
            <h2 className="heading-24 info-section__heading">Contacts</h2>
            <div className="section--contacts__block">
              <p className="info-section__description-grey">
                CGTrader is an international company with offices in Europe and the US.
              </p>
            </div>
          </div>
          <div className="follow-links">
            <SocialButtons
              socialNetworks={['facebook', 'linkedin', 'twitter', 'pinterest', 'youtube']}
              page="About"
              className="social-icon-circle--large"
              useSquareIcons
            />
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-5 offset-lg-2">
          <div className="row">
            <div className="col-12 col-md-6">
              <div>
                <p className="contacts__subtitle">Address</p>
                <div className="info-section__description-grey">
                  <span className="text-semibold">EMEA</span>
                  <p>
                    Antakalnio st. 17
                    <br />
                    LT-10312 Vilnius
                    <br />
                    Lithuania
                  </p>
                  <span className="text-semibold">North America</span>
                  <p>
                    7208 W. Sand Lake Road
                    <br />
                    Suite 305
                    <br />
                    Orlando, FL 32819
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="section--contacts__block">
                <p className="contacts__subtitle">Customer support</p>
                <p className="info-section__description-grey">
                  support@cgtrader.com<br />
                  <small>
                    <i>
                      Please note that our Support team works Monday to Friday, so requests sent out of business hours
                      and on the weekend might take longer than usual.
                    </i>
                  </small>
                </p>

                <p className="contacts__subtitle">Vendors, partners, sales</p>
                <p className="info-section__description-grey">info@cgtrader.com</p>
              </div>
            </div>
          </div>
        </div>
      </Section>
    </Element>
  )
}

Contacts.propTypes = {
  id: PropTypes.string.isRequired,
}

export default Contacts
